import styled from "styled-components";

const PluginText = styled.div.attrs({
  className: "pv2"
})`
  color: #222222;
  font-size: 16px;
  letter-spacing: 0.01px;
  line-height: 26px;
`;

export default PluginText;
